<script setup lang="ts">
import { computed } from 'vue'
import { usePageContext } from '@/composables/usePageContext'
import HelpLayout from '../HelpLayout.vue'

interface ArticleCategory {
  id: number
  code: string
  name: string
}

interface ArticleData {
  id: number
  codename: string
  title: string
  html: string
  category: ArticleCategory
}

interface OtherArticle {
  id: number
  title: string
}

interface ArticleContext {
  data: ArticleData
  other_articles: OtherArticle[]
}

const ctx = usePageContext<ArticleContext>()

const breadcrumbs = computed(() => {
  const { data } = ctx
  const { category } = data
  return [
    { label: 'Все разделы', href: '/help/center' },
    { label: category.name, href: `/help/category/${category.code}` },
    { label: data.title }
  ]
})
</script>

<template>
  <HelpLayout :contact-form-category="ctx.data.category.code">
    <div class="help-article">
      <v-breadcrumbs :items="breadcrumbs" class="mb-5" />

      <div class="help-article__container">
        <ul class="help-article__links">
          <li v-for="article in ctx.other_articles" :key="article.id">
            <v-link mode="primary" :href="`/help/article/${article.id}`">
              {{ article.title }}
            </v-link>
          </li>
        </ul>

        <article class="help-article__content" v-html="ctx.data.html" />
      </div>
    </div>
  </HelpLayout>
</template>

<style lang="scss">
@use '@/styles/pages/help/article.scss' as *;
</style>
